/**
 * Nudges Service
 *
 * Service for managing nudges (user notifications) via the integrated backend API.
 *
 * All endpoints: /pfm/nudges/*
 */

import { httpClient } from './http-client.service';
import type {
  NudgeFormData,
  NudgeCreateResponse,
  NudgeListResponse,
  NudgeExecuteResponse,
  UpdateNudgeResponse,
  DeleteNudgeResponse
} from '../types/nudges';

class NudgesService {
  /**
   * GET /pfm/nudges
   * Lists all nudges for the current business (backend determines business)
   */
  async getNudges(): Promise<NudgeListResponse> {
    try {
      const response = await httpClient.get('pfm/nudges');

      console.log('Nudges fetched successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching nudges:', error);
      throw error;
    }
  }

  /**
   * POST /pfm/nudges/create
   * Creates a new nudge (backend attaches business context)
   */
  async createNudge(formData: NudgeFormData): Promise<NudgeCreateResponse> {
    try {
      const requestPayload = {
        ...formData
      };
      const response = await httpClient.post('pfm/nudges/create', requestPayload);

      console.log('Nudge created successfully:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error creating nudge:', error);
      throw error;
    }
  }

  /**
   * POST /pfm/nudges/execute
   * Executes a nudge immediately
   */
  async executeNudge(nudgeId: string): Promise<NudgeExecuteResponse> {
    try {
      const requestPayload = { nudge_id: nudgeId };

      const response = await httpClient.post('pfm/nudges/execute', requestPayload);

      console.log('Nudge executed successfully:', nudgeId);
      return response.data;
    } catch (error) {
      console.error('Error executing nudge:', error);
      throw error;
    }
  }

  /**
   * PUT /pfm/nudges/:nudgeId
   * Updates an existing nudge 
   */
  async updateNudge(nudgeId: string, formData: Partial<NudgeFormData>): Promise<UpdateNudgeResponse> {
    try {
      const requestPayload = {
        ...formData
      };

      const response = await httpClient.put(`pfm/nudges/${nudgeId}`, requestPayload);

      console.log('Nudge updated successfully:', nudgeId);
      return response.data;
    } catch (error) {
      console.error('Error updating nudge:', error);
      throw error;
    }
  }

  /**
   * DELETE /pfm/nudges/:nudgeId
   * Deletes a nudge 
   */
  async deleteNudge(nudgeId: string): Promise<DeleteNudgeResponse> {
    try {

      const response = await httpClient.delete(`pfm/nudges/${nudgeId}`);

      console.log('Nudge deleted successfully:', nudgeId);
      return response.data;
    } catch (error) {
      console.error('Error deleting nudge:', error);
      throw error;
    }
  }
}

export const nudgesService = new NudgesService();

export type { NudgeFormData as CreateNudgeFormData } from '../types/nudges';